<script>
  import { fly, fade } from 'svelte/transition';
  import { Icon, ChevronDown } from 'svelte-hero-icons';
  
  export let submenu = {};
  export let pathgroup = [];

  let toggle = false;
</script>

<div class="relative" on:mouseenter={() => toggle = true} on:mouseleave={() => toggle = false}>
  <a href={submenu.url} class="ti-menu p-2 inline-flex items-center text-base font-medium hover:text-orange-400" class:ti-menu-checked={pathgroup.indexOf(submenu.key) !== -1}>
    {submenu.name}
    <!-- Heroicon name: outline/chevron_down -->
    <Icon src={ChevronDown} solid class="text-gray-400 h-5 w-5 group-hover:text-gray-500" />
  </a>

  <!-- Submenu -->
  <div class:hidden={!toggle} in:fly="{{duration: 300}}" out:fade>
    <div class="absolute left-0 mt-0 transform">
      <div class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
        <nav class="grid bg-white">
          {#each submenu.children as menu}
            <a href={menu.url} class="flex items-center w-28 px-4 py-2 text-base text-gray-500 hover:text-orange-400" class:ti-menu-checked={pathgroup.indexOf(menu.key) !== -1} on:click={() => toggle = false}>
              {menu.name}
            </a>
          {/each}
        </nav>
      </div>
    </div>
  </div>
</div>
